import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DefaultLayout from 'public/components/DefaultLayout';
import { useFilterDispatch } from 'public/context/FilterContext';
import { Spinner } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import useMarketType from 'utils/useMarketType';
import FarmView from './FarmView';
import { FarmGlobalStyle } from './style';

const FarmPage = () => {
  const { id } = useParams<{ slug: string; id: string }>();
  const dispatchFilter = useFilterDispatch();
  const { marketType } = useMarketType();

  const { isLoading: isLoadingFarm, data: farm } = useQueryApiClient({
    request: {
      url: `api/v2/farms/${id}`,
      data: { marketType },
    },
  });

  const {
    isLoading: isLoadingProducts,
    data: farmProducts,
    appendData: fetchProducts,
  } = useQueryApiClient({
    request: {
      url: `api/v2/farms/${id}/products`,
      data: { page: 1, marketType },
    },
  });

  useEffect(() => {
    dispatchFilter({
      type: 'SAVE_PAYLOAD',
      payload: { isFilter: false, openCloseDrawer: () => null },
    });
  }, [dispatchFilter]);

  return (
    <DefaultLayout.PageLayout>
      <DefaultLayout.PageContent className={'no-padding'}>
        <FarmGlobalStyle />
        <Spinner spinning={isLoadingFarm || isLoadingProducts}>
          <FarmView
            farm={farm}
            farmProducts={farmProducts}
            onFarmProductsPageChange={(page) =>
              fetchProducts({ page, marketType })
            }
          />
        </Spinner>
      </DefaultLayout.PageContent>
    </DefaultLayout.PageLayout>
  );
};

export default FarmPage;
